// -- Import Actions
import { commonActions } from  '../../actions/commonActions';
import {posSetItem,POS_USER_ID,posGetItem} from '../../actions/posActions';
import {userGetItem} from '../../actions/userActions';
import { connect } from 'react-redux';
import AddEditForm from '../../components/pos/PosAddEditForm';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as bankList} from '../../containers/financial/BankListPage';


const mapStateToProps = state => {
    return {
        common: state.common,
        initialValues: state.pos.targetItem,
        userValue: state.app.currentUser,
        bankList  : state.financial.bankList,
        userInfo  : state.user.getItem,
        posInfo  : state.pos.getItem,
    }
};


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getItem: (id) => {
        dispatch(getItem(id));
    },
    getBankList : () => {
        return(dispatch(bankList()));
    },
    setUserId: (userId) => {
        return(dispatch({type: POS_USER_ID, data: userId}))
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(edit(value));
    },

});


/* ------------------------------------------------ */
/* -------- Functions of mapDispatchToProps ------- */
/* ------------------------------------------------ */

const edit = (values) => {

    return (dispatch, getState) => {
        const states = getState();
        let userId = states.pos.posUserId

        let formData = {
            'pos_serial'   : values.pos_serial ? values.pos_serial: states.pos.getItem.pos_serial,
            'bank_account' : values.bank_account ? values.bank_account : states.pos.getItem.bank_account
        };

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.put('user/app/pos/'+userId, formData).then(editRes => {
            dispatch(posSetItem(editRes.data));
            if(editRes.data.status === true) {
                dispatch({type: commonConstants.FORM_SUCCESS});
                dispatch({
                    type: alertConstants.SUCCESS,
                    message: 'عملیات شما با موفقیت انجام شد'
                })
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
                dispatch({
                    type: alertConstants.ERROR,
                    message: 'خطا در ویرایش'
                })
            }
        }).catch(error => {
            dispatch({type: commonConstants.FORM_FAILURE});
            dispatch({
                type: alertConstants.ERROR,
                message: 'خطای سرور'
            })
        });

    }
}

const getItem = (id) => {

    return (dispatch, getState) => {

        API_FETCH.get('user/'+id).then(posInfo => {
            dispatch(userGetItem(posInfo.data));
            dispatch(posGetItem(posInfo.data.pos));
        }).catch(error => {
            console.log(error);
        });
    }
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditForm);
